import React from 'react';

import {
  IconArchive,
  IconCalendar,
  IconCalendarCheck,
  IconFileInvoice,
  IconUserCircle,
} from '@tabler/icons-react';
import MobileLayout from 'layouts/MobileLayout';
import { Navigate } from 'react-router-dom';

import { IRouteMap } from './types';

export const athleteRouteMap: IRouteMap = {
  layout: MobileLayout,
  routes: [
    {
      key: 'schedule',
      component: React.lazy(() => import('pages/private/athlete/Schedule')),
      path: '/',
    },
    {
      key: 'packages',
      component: React.lazy(() => import('pages/private/athlete/Packages')),
      path: '/packages',
    },
    {
      key: 'salesPortal',
      component: React.lazy(() => import('pages/private/athlete/AthleteSalesPortal/SalesPortalHomePage')),
      path: '/packages/sales-portal',
    },
    {
      key: 'salesPortalPackage',
      component: React.lazy(() => import('pages/private/athlete/AthleteSalesPortal/SalesPortalPackagePage')),
      path: '/packages/sales-portal/:packageId',
    },
    {
      key: 'salesPortalBillingPlan',
      component: React.lazy(
        () => import('pages/private/athlete/AthleteSalesPortal/SalesPortalBillingPlanPage'),
      ),
      path: '/packages/sales-portal/:packageId/:billingPlanId',
    },
    {
      key: 'events',
      component: React.lazy(() => import('pages/private/athlete/Events')),
      path: '/events',
    },
    {
      key: 'attendance',
      component: React.lazy(() => import('pages/private/athlete/Attendance')),
      path: '/events/attendance',
    },
    {
      key: 'class',
      component: React.lazy(() => import('pages/private/athlete/EventDetail')),
      path: '/classes/:eventId',
    },
    {
      key: 'appointment',
      component: React.lazy(() => import('pages/private/athlete/EventDetail')),
      path: '/appointments/:eventId',
    },
    {
      key: 'classLeaderboard',
      component: React.lazy(() => import('pages/private/athlete/Leaderboard')),
      path: '/classes/:eventId/leaderboard',
    },
    {
      key: 'documents',
      component: React.lazy(() => import('pages/private/athlete/Documents')),
      path: '/documents/:tab',
    },
    {
      key: 'document',
      component: React.lazy(() => import('pages/private/athlete/DocumentDetail')),
      path: '/documents/:tab/:documentId',
    },
    {
      key: 'invoice',
      component: React.lazy(() => import('pages/private/athlete/InvoiceDetail')),
      path: '/invoices/:invoiceId',
    },
    {
      key: 'athletePackage',
      component: React.lazy(() => import('pages/private/athlete/AthletePackageDetail')),
      path: '/packages/:athletePackageId',
    },
    {
      key: 'account',
      component: React.lazy(() => import('pages/private/athlete/Account')),
      path: '/account',
    },
    {
      key: 'redirect',
      component: () => Navigate({ to: '/' }),
      path: '*',
    },
  ],
  navLinks: [
    {
      key: 'packages',
      Icon: IconArchive,
      label: 'Packages',
      route: '/packages',
    },
    {
      key: 'events',
      Icon: IconCalendarCheck,
      label: 'My Events',
      route: '/events',
    },
    {
      key: 'schedule',
      Icon: IconCalendar,
      label: 'Schedule',
      route: '/',
    },
    {
      key: 'documents',
      Icon: IconFileInvoice,
      label: 'Documents',
      route: '/documents/unsigned',
    },
    {
      key: 'account',
      Icon: IconUserCircle,
      label: 'Account',
      route: '/account',
    },
  ],
};

export const getAthleteRouteMap = (): IRouteMap => {
  return athleteRouteMap;
};
